import _, { forEach } from "lodash";
import React, { useMemo } from "react";
import CustomSelect from "../../common/CustomSelect";
import { Lead} from './LeadDataGridStore';
import { SelectOption } from 'src/types/common';
import { client } from 'src/utils/axios-client';
import { Box, Chip, LinearProgress, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/ErrorOutline';
import { useAuth } from "../../../hooks/useAuth";
import ExcelImportStore from "./ExcelImportStore";

type Props = {
    lead: Lead,
}

const ValidationColumn = ({ lead }: Props) => {
    const [loading, setLoading] = React.useState(true);
    const [success, setSuccess] = React.useState(false);
    const { user } = useAuth();

    React.useEffect(() => {                
        validateLead();
    }, [lead])


    if (!user) return null;

    const fieldsToCheck = useMemo(() => {        
        return JSON.parse(user.fieldsToCheck) as string[];
    }, [user.fieldsToCheck]);

    const validateLead = async () => {
        let hasError = false;
        let needsUpdate = false;
        const tempLead = _.cloneDeep(lead);

        //var fieldsToCheck = ['firstName', 'lastName', 'emailAddress', 'company', 'jobTitle', 'linkedIn', 'leadLevelId', 'switchboard', 'phone',
        //    'phone', 'mobile', 'city', 'province', 'countryId', 'leadSourceId', 'leadFunctionId', 'industryId', 'addressRegionId', 'leadOwnerId']

        fieldsToCheck.forEach(field => {            
            const errorField = field + 'Error';            

            if (_.isEmpty(tempLead[field])) {
                needsUpdate = needsUpdate || (!tempLead[errorField] || tempLead[errorField] === undefined)

                tempLead[errorField] = true;    
                hasError = true;
            } else if (tempLead[errorField]) {
                tempLead[errorField] = false;
                needsUpdate = true;
            }
        })

        if (!tempLead.isValid || tempLead.isValid != !hasError) {
            needsUpdate = true;
        }

        tempLead.isValid = !hasError;

        if (needsUpdate) {
            ExcelImportStore.update((s, o) => {
                const leadIndex = o.leads.findIndex(s => s.id === tempLead.id);

                if (leadIndex > -1) {
                    s.leads[leadIndex] = tempLead;
                }
            });
        }

        setSuccess(!hasError)
        setLoading(false);
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    {loading && <LinearProgress color='success' />}
                    {!loading && success && <Chip sx={{ width: '100%' }} icon={<DoneIcon />} color='success' size='small' />}
                    {!loading && !success && <Chip sx={{ width: '100%' }} icon={<ErrorIcon />} color='error' size='small' />}
                </Box>
            </Box>
        </Box>
    )
}

export { ValidationColumn }
export default ValidationColumn;